<template>
    <b-overlay :show="loading" rounded="sm">
        <div v-if="masterData">
            <table class="table table-bordered table-sm mb-2">
                <tbody>
                    <tr>
                        <th class="w-25">İşlem Numarası</th>
                        <td>{{ masterData.Id }}</td>
                    </tr>
                    <tr>
                        <th>Oluşturan</th>
                        <td>{{ masterData.UserName }}</td>
                    </tr>
                    <tr>
                        <th>Oluşturma Zamanı</th>
                        <td>{{ formattedCreateTime }}</td>
                    </tr>
                    <tr>
                        <th>Durum</th>
                        <td>{{ formattedMasterStatusTr }} ({{ masterData.SuccessItemCount }} / {{ masterData.TotalItemCount }})</td>
                    </tr>
                </tbody>
            </table>

            <div>
                <div @click="showItems = !showItems" class="d-flex justify-content-between align-items-center cursor-pointer p-1 bg-light border">
                    <h5 class="mb-0">İşlem Satırları</h5>
                    <feather-icon :icon="showItems ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
                </div>
                <b-collapse v-model="showItems" id="item-details-collapse">
                    <div class="table-responsive table-bordered border-top-0">
                        <table class="table table-striped table-sm mb-0">
                            <thead>
                                <tr>
                                    <th class="text-nowrap">G/C</th>
                                    <th class="text-nowrap">Muhasebe Kodu</th>
                                    <th class="text-nowrap">Proje Kodu</th>
                                    <th class="text-nowrap">Tutar</th>
                                    <th class="text-nowrap">Kasa Açıklaması</th>
                                    <th class="text-nowrap">Tarih</th>
                                    <th class="text-nowrap">Fiş No</th>
                                    <th class="text-nowrap">Hata Mesajı</th>
                                    <th class="text-nowrap">Durum</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in masterData.Items" :key="index">
                                    <td class="text-nowrap">{{ item.GelirGider }}</td>
                                    <td class="text-nowrap">{{ item.AccountingCode }}</td>
                                    <td class="text-nowrap">{{ item.ProjectCode }}</td>
                                    <td class="text-right text-nowrap">{{ item.amountStr }}</td>
                                    <td class="text-nowrap">{{ item.KasaAciklamasi }}</td>
                                    <td class="text-nowrap">{{ item.tarihStr }}</td>
                                    <td class="text-nowrap text-right">{{ item.ReturnValue || "-" }}</td>
                                    <td class="text-nowrap">
                                        <span v-if="item.ReturnValueDescription" v-b-tooltip.hover.top="item.ReturnValueDescription">
                                            {{ item.ReturnValueDescription.slice(0, 12) + (item.ReturnValueDescription.length > 10 ? "..." : "") }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="text-nowrap" :class="getStatusClass(item.Status)">
                                        <strong>{{ item.statusTr }}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-collapse>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay, BCollapse, VBTooltip } from "bootstrap-vue";
import VaultOperationsApi from "@/api/vault-operations";
import moment from "moment";

export default {
    components: {
        BOverlay,
        BCollapse,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        masterId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            masterData: null,
            showItems: true,
        };
    },
    computed: {
        formattedCreateTime() {
            if (!this.masterData) return "";
            return moment(this.masterData.CreateTime).format("DD.MM.YYYY HH:mm:ss");
        },
        formattedMasterStatusTr() {
            if (!this.masterData) return "";
            const statusMap = {
                Success: "Başarılı",
                Failed: "Hatalı",
                InProgress: "İşleniyor",
                Pending: "Beklemede",
                Cancelled: "İptal Edildi",
            };
            return statusMap[this.masterData.Status] || this.masterData.Status;
        },
    },
    created() {
        this.fetchDetails();
    },
    methods: {
        fetchDetails() {
            this.loading = true;
            VaultOperationsApi.Vault.GetTransactionBatchDetail(this.masterId)
                .then((res) => {
                    if (res.data.Success) {
                        const data = res.data.Data;
                        const statusMap = {
                            Success: "Başarılı",
                            Failed: "Hatalı",
                            InProgress: "İşleniyor",
                            Pending: "Beklemede",
                            Cancelled: "İptal Edildi",
                        };

                        if (data.Items && data.Items.length > 0) {
                            data.Items.forEach((item) => {
                                const amount = item.Amount || 0;
                                item.amountStr =
                                    new Intl.NumberFormat("tr-TR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(amount) + " ₺";

                                item.statusTr = statusMap[item.Status] || item.Status;
                                item.tarihStr = moment(item.Tarih).format("DD.MM.YYYY");
                            });
                        }
                        this.masterData = data;
                    } else {
                        this.$result(res);
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        getStatusClass(status) {
            const classMap = {
                Success: "text-success",
                Failed: "text-danger",
                InProgress: "text-info",
                Pending: "text-secondary",
                Cancelled: "text-warning",
            };
            return classMap[status] || "";
        },
    },
};
</script>
